import apollo from '@/graphql'

import SaveVendorDetails from '@/graphql/vendor/SaveVendorDetails.gql'
import UploadVendorLogo from '@/graphql/vendor/UploadVendorLogo.gql'
import VendorDetailsQuery from '@/graphql/vendor/VendorDetailsQuery.gql'

// initial state
const state = {
  editableVendorFields: {},
  vendorDetails: {},
}

// getters
const getters = {
  editableVendorFields: st => st.editableVendorFields,
  vendorDetails: st => st.vendorDetails,
}

// mutations
const mutations = {
  createVendorDetails() {
    state.editableVendorFields = { companyType: 'vendor' }
    state.vendorDetails = { name: 'New Vendor' }
  },

  setEditableVendorFields(st, vendorDetails) {
    state.editableVendorFields = {
      id: vendorDetails.id,
      name: vendorDetails.name,
      phone: vendorDetails.phone,
    }
  },

  setVendorDetails(st, vendorDetails) {
    state.vendorDetails = vendorDetails
  },

  updateVendorFields(st, fields) {
    Object.assign(state.editableVendorFields, fields)
  },
}

// actions
const actions = {
  loadVendorDetails({ commit }, { id }) {
    apollo.defaultClient
      .watchQuery({
        fetchPolicy: 'network-only',
        query: VendorDetailsQuery,
        variables: { id: +id },
      })
      .subscribe(({ data: { vendorDetails } }) => {
        commit('setEditableVendorFields', vendorDetails)
        commit('setVendorDetails', vendorDetails)
      })
  },

  saveVendorDetails(context, { $message, $router }) {
    apollo.defaultClient
      .mutate({
        mutation: SaveVendorDetails,
        variables: {
          fields: state.editableVendorFields,
        },
        refetchQueries: [state.vendorDetails.id].filter(id => id).map(id => ({
          query: VendorDetailsQuery,
          variables: { id },
        })),
      })
      .then(({ data: { saveCompanyDetails: { id } } }) => {
        $message({ message: 'Changes saved' })
        $router.push(`/vendor/${id}`)
      })
      .catch((err) => {
        $message.error(err.message)
      })
  },

  async uploadVendorLogo(context, { file }) {
    try {
      await apollo.defaultClient.mutate({
        mutation: UploadVendorLogo,
        variables: { id: state.vendorDetails.id, file },
        refetchQueries: [
          {
            query: VendorDetailsQuery,
            variables: { id: state.vendorDetails.id },
          },
        ],
      })
    } catch (err) {
      throw new Error(err.graphQLErrors[0].message)
    }
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/vendor/VendorDetails.js